import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {baseStyles, BORDER_RADIUS, changeNavColor, withMediaQueries, withMultipleStyles} from "src/styles/Styles";
import {
  ErrorText,
  ErrorViewEx,
  ImageIcon,
  locString,
  SNACKBAR_AUTO_HIDE_DURATION
} from "src/js/components/commons/ViewHelper";
import {deletePaymentCard, fetchSavedCards} from "src/js/actions/paymentActions";
import CircularProgress from "@material-ui/core/CircularProgress";
import {TAP_PAYMENT_TOKEN} from "src/js/utils/services";
import 'src/styles/tap-payment.css';
import {
  ColorBackground,
  ColorBackgroundXS,
  ColorClear,
  ColorNegative,
  ColorStatusDialog,
  ColorSubTitle,
  ColorTitle
} from "src/styles/Colors";
import {logDebug} from "src/js/utils/AppLog";
import {Button, FormControl, IconButton, List} from "@material-ui/core";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import {FormattedMessage} from "react-intl";
import Space from "src/js/components/commons/Space";
import FieldSpace from "src/js/components/commons/FieldSpace";
import SectionHeaderView from "src/js/components/commons/SectionHeaderView";
import View from "src/js/components/commons/View";
import AppText from "src/js/components/commons/AppText";
import {FontWeightMedium} from "src/res/FontWeight";
import {AppIcon, IconCircle} from "src/js/components/commons/AppIcon";
import ListItem from "@material-ui/core/ListItem";
import DialogView from "src/js/components/commons/DialogView";
import Loader from "src/js/components/commons/Loader";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import {getErrorFromResponse} from "src/js/utils/ApiHelper";
import TextView from "src/js/components/commons/TextView";
import {Skeleton} from "@material-ui/lab";
import DateTimeHelper from "src/js/utils/DateTimeHelper";
import ValueHelper from "src/js/utils/ValueHelper";
import TextField from "@material-ui/core/TextField";
import constants from "src/js/constants";

const useStyles = (theme) => ({
  mainContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 458,
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      minHeight: 412,
    }
  },
  buttonCard: {
    minHeight: 48,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: 12,
    paddingBottom: 12,
    [theme.breakpoints.up('sm')]: {
      borderRadius: BORDER_RADIUS,
      backgroundColor: ColorBackground,
      marginBottom: 16
    }
  }
});

class ManageActivityPayment extends React.Component {

  constructor(props) {
    super(props);
    // this.scriptTapPay1 = document.createElement("script");
    // this.scriptTapPay1.src = "https://cdnjs.cloudflare.com/ajax/libs/bluebird/3.3.4/bluebird.min.js";
    // this.scriptTapPay1.async = true;
    // this.scriptTapPay2 = document.createElement("script");
    // this.scriptTapPay2.src = "https://secure.gosell.io/js/sdk/tap.min.js";
    // this.scriptTapPay2.async = true;

    this.state = {
      isFetching: false,
      isInAddCard: false,
      isTokenizingCard: false,
      cards: null,
      isAddCardLoaded: false,
      saveCard: true,
      cardId: null,
      tokenId: null,
      billingName: this.props.activityData.business.billingName || this.props.activityData.business.name,
      showValidationMsg: false,
    };
  }

  componentDidMount() {
    // document.body.appendChild(this.scriptTapPay1);
    // document.body.appendChild(this.scriptTapPay2);

    this.props.moveNextCallback(this);
    this.makeApiToFetchCards();
  }

  componentWillUnmount() {
    // document.body.removeChild(this.scriptTapPay1);
    // document.body.removeChild(this.scriptTapPay2);
  }

  updateState(fields) {
    this.setState(fields, () => {
      this.props.onDataUpdated(this.getData(true));
    });
  }

  getData(excludeError) {
    const {billingName, cardId, tokenId, saveCard} = this.state;

    if (!excludeError) {
      if (!billingName || billingName.trim().length < 5) {
        this.updateState({showValidationMsg: true});
        return false;
      }
    }

    return {
      billingName: billingName,
      cardId: cardId,
      tokenId: tokenId,
      saveCard: saveCard,
    };
  }

  render() {
    const {app, classes, isXS} = this.props;
    const {isInAddCard, isFetching, error, cards, billingName, showValidationMsg, isBlockedLoading} = this.state;

    if (isFetching) {
      return (
        <div className={classes.mainContainer}>
          <div className={classes.flexColumn} style={{justifyContent: 'center'}}><CircularProgress /></div>
        </div>
      )
    }
    if (error) {
      return (
        <div className={classes.mainContainer}>
          <ErrorViewEx classes={classes} error={error} onRetryClicked={this.onRetryClicked} />
        </div>
      )
    }

    let billNameError = null;
    if (showValidationMsg) {
      if (!billingName || billingName.trim().length < 5) {
        billNameError = <FormattedMessage id='activity.validationBillName'/>;
      }
    }

    const spacingSide = isXS ? 16 : 0;
    const marginLeft = !app.isLTR ? 12 : 0;
    const marginRight = app.isLTR ? 12 : 0;
    return (
      <div className={classes.mainContainer} style={{maxWidth: 600, paddingTop: isXS ? 4 : 0}}>
        <SectionHeaderView labelId={'activity.billingInfo'} />
        <TextField
          variant="filled"
          fullWidth
          required
          size="small"
          type="text"
          id="billingName"
          name="billingName"
          label={<FormattedMessage id={'activity.billingName'}/>}
          InputProps={{disableUnderline: true}}
          inputProps={{maxLength: 200}}
          value={billingName}
          onChange={this.onChange}
          error={billNameError}
          helperText={billNameError}
        />
        <FieldSpace multiplier={4}/>

        {isInAddCard
          ? this.renderAddCardUI()
          : <React.Fragment>
            <Button
              disableElevation={true}
              size={'large'}
              color={'primary'}
              variant={'contained'}
              onClick={this.onAddNewCardClicked}>
              <FormattedMessage id={'payment.addNewCard'}/>
            </Button>
            <FieldSpace multiplier={1}/>
            <SectionHeaderView labelId={'payment.savedCards'} />
            {cards && cards.length > 0 ?
              <List disablePadding dense style={{marginLeft: -spacingSide, marginRight: -spacingSide}}>
                {cards.map((item) => {
                  const title = item.name;
                  const lastFour = item.lastFour;
                  const imageUrl = item.imageUrl;
                  const cardMethod = item.cardMethod;
                  const month = item.expMonth;
                  const year = item.expYear;
                  const isExpired = item.isExpired;
                  return (
                    <ListItem
                      divider={isXS}
                      button
                      key={item.id}
                      className={classes.buttonCard}
                      onClick={() => {
                        this.setState({cardId: item.id, tokenId: null}, () => {
                          this.props.moveNext();
                        });
                      }}>
                      <img src={imageUrl} width={40} height={40} style={{borderRadius: 4}}/>
                      <Space verticalSpace={1.5}/>
                      <View style={{flex: 1}}>
                        <AppText numberOfLines={1} color={ColorTitle}>
                          {title}
                        </AppText>
                        <View className={classes.flexRowWrap}>
                          <AppText
                            variant={'body2'}
                            style={{
                              fontWeight: FontWeightMedium,
                              color: ColorSubTitle, marginLeft: marginLeft, marginRight: marginRight}}>
                            {cardMethod}
                          </AppText>
                          <View style={{marginLeft: marginLeft, marginRight: marginRight, justifyContent: 'center'}}>
                            <AppIcon icon={IconCircle} color={ColorSubTitle} style={{width: 2, height: 2}} />
                          </View>
                          <AppText
                            variant={'body2'}
                            style={{
                              fontWeight: FontWeightMedium,
                              color: ColorSubTitle,
                              marginLeft: marginLeft, marginRight: marginRight}}>
                            {lastFour}
                          </AppText>
                          <View style={{marginLeft: marginLeft, marginRight: marginRight, justifyContent: 'center'}}>
                            <AppIcon icon={IconCircle} size={2} color={ColorSubTitle} style={{width: 2, height: 2}} />
                          </View>
                          <AppText
                            variant={'body2'}
                            style={{
                              fontWeight: FontWeightMedium,
                              marginLeft: marginLeft, marginRight: marginRight,
                              color: ColorSubTitle}}>
                            <FormattedMessage id={'payment.monthYear'} values={{valueMonth: month, valueYear: year}} />
                          </AppText>
                          {isExpired ?
                            <AppText
                              variant={'body2'}
                              style={{
                                marginLeft: marginLeft, marginRight: marginRight,
                                fontWeight: FontWeightMedium,
                                color: ColorNegative}}>
                              {locString('payment.cardExpired')}
                            </AppText>
                            : null
                          }
                        </View>
                      </View>
                      <Space verticalSpace={2}/>
                      <IconButton size={'small'} onClick={this.onDeleteCardClicked.bind(this, item.id)} className={classes.imageIconButton}
                        style={{marginLeft: !app.isLTR ? -8 : 0, marginRight: app.isLTR ? -8 : 0}}>
                        {<ImageIcon src={require('src/images/ic_delete_bg.png')} width={38} height={38} />}
                      </IconButton>
                    </ListItem>
                  )})
                }
              </List>
              : <TextView color={ColorSubTitle} fontWeight={FontWeightMedium}><FormattedMessage id={'payment.noSavedCards'} /></TextView>
            }
          </React.Fragment>
        }
        {isBlockedLoading && <Loader/>}
        {this.getDialogView()}
        {this.renderSnackBar()}
      </div>
    );
  }

  renderSnackBar() {
    const {snackbarMessageId, snackbarMessage, snackbarType} = this.state;
    const onClose = () => {
      this.setState({snackbarMessageId: null, snackbarMessage: null, snackbarType: null});
    };
    return (
      <Snackbar open={snackbarMessageId || snackbarMessage} autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION} onClose={onClose}>
        <MuiAlert severity={snackbarType || "success"} onClose={onClose} elevation={6} variant="filled">
          {snackbarMessageId ? <FormattedMessage id={snackbarMessageId} /> : snackbarMessage}
        </MuiAlert>
      </Snackbar>
    );
  }

  getDialogView() {
    const {classes} = this.props;
    const {showDialog, dialogInfo} = this.state;
    if (!showDialog) {
      return null;
    }

    return (
      <DialogView
        classes={classes}
        show={showDialog}
        {...dialogInfo}
      />
    );
  }

  showDialog(dialogInfo) {
    if (dialogInfo) {
      changeNavColor(ColorStatusDialog);
      this.setState({showDialog: true, dialogInfo: dialogInfo});
    }
  }

  hideDialog = () => {
    changeNavColor(this.props.isXS ? ColorBackgroundXS : ColorBackground);
    this.setState({showDialog: false, dialogInfo: null});
  }

  onChange = (event) => {
    const value = event.target.value;
    this.updateState({[event.target.name]: value, showValidationMsg: false});
  };

  onAddNewCardClicked = () => {
    const data = this.getData();
    if (!data) {
      return;
    }
    this.setState({isFetching: false, isInAddCard: true, saveCard: true}, () => {
      this.processAddCardRecur();
    });
  }

  onDeleteCardClicked = (id, event) => {
    event.stopPropagation();
    this.showDialog({
      title: <FormattedMessage id={'payment.deleteCardQ'} />,
      positiveText: <FormattedMessage id={'payment.deleteCard'} />,
      neutralText: <FormattedMessage id={'generic.cancel'} />,
      onPositiveClicked: this.onDeleteCard.bind(this, id),
      onNeutralClicked: this.hideDialog,
    });
  }

  onDeleteCard = (id) => {
    this.hideDialog();
    this.setState({isBlockedLoading: true});
    this.props.deletePaymentCard(id).then(() => {
      const cards = this.state.cards;
      let index = -1;
      for (let i = 0; i < cards.length; i++) {
        if (cards[i].id === id) {
          index = i;
        }
      }
      if (index !== -1) {
        cards.splice(index, 1);
      }
      this.setState({isBlockedLoading: false, cards: cards, snackbarMessageId: 'payment.cardDeleted'});
    }).catch((response) => {
      const error = getErrorFromResponse(response, this.context.intl);
      this.setState({isBlockedLoading: false, snackbarMessageId: error, snackbarType: 'error'});
    });
  }

  processAddCardRecur() {
    try {
      setTimeout(() => {
        this.processAddCard();
      }, 100);
    } catch (ex) {
      setTimeout(() => {
        this.processAddCardRecur();
      }, 500);
    }
  }

  processAddCard() {
    const {app} = this.props;
    const _this = this;

    const stringCardNumber = this.context.intl.formatMessage({id: 'payment.stringCardNumber'});
    const stringCardExpiry = this.context.intl.formatMessage({id: 'payment.stringCardExpiry'});
    const stringCvv = this.context.intl.formatMessage({id: 'payment.stringCvv'});
    const stringCardHolderName = this.context.intl.formatMessage({id: 'payment.stringCardHolderName'});

    const tap = Tapjsli(TAP_PAYMENT_TOKEN);
    const elements = tap.elements({});

    const style = {
      base: {
        color: ColorTitle,
        backgroundColor: ColorClear,
        // lineHeight: '24px',
        fontFamily: app.isLTR ? 'Poppins, sans-serif' : 'Noto Kufi Arabic, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#979b9f',
          fontSize: '16px'
        }
      },
      invalid: {
        color: ColorNegative
      }
    };
    const labels = {
      cardNumber: stringCardNumber,
      expirationDate: stringCardExpiry,
      cvv: stringCvv,
      cardHolder: stringCardHolderName
    };
    const paymentOptions = {
      currencyCode: ['SAR'],
      labels: labels,
      TextDirection: app.isLTR ? 'ltr' : 'rtl'
    }
    const card = elements.create('card', {style: style}, paymentOptions);
    card.mount('#element-container');

    card.addEventListener('change', function (event) {
      logDebug('onChangePaymentCalled', event.loaded);
      if (event.loaded) { //If ‘true’, js library is loaded
        console.log("UI loaded :"+event.loaded);
        console.log("current currency is :"+card.getCurrency())
        _this.setState({isAddCardLoaded: true});
      }

      if (event.BIN) {
        console.log(event.BIN)
      }

      if (event.error || event.error_interactive) {
        let errorMessage = null;
        if (event.error && event.error.message) {
          errorMessage = event.error.message;
        } else if (event.error_interactive && event.error_interactive.message) {
          errorMessage = event.error_interactive.message;
        }
        _this.setState({addCardError: errorMessage});
      } else {
        _this.setState({addCardError: null});
      }
    });

    this.onGenerateNewCardTokenClicked = () => {
      this.setState({isTokenizingCard: true});
      const promise = tap.createToken(card);
      if (promise) {
        promise.then(this.onNewCardTokenGenerated).catch((error) => {
          console.log(error);
          this.setState({isTokenizingCard: false, addCardError: error});
        });
      }
    };

    this.setState({reload: !this.state.reload});
  }

  onNewCardTokenGenerated = (result) => {
    if (result.error) {
      console.log(result.error.message);
      this.setState({isTokenizingCard: false, addCardError: result.error.message});
    } else {
      console.log('tokenId', result.id);
      this.setState({isTokenizingCard: false, tokenId: result.id, cardId: null, reload: null}, () => {
        this.props.moveNext();
      });
    }
  }

  renderAddCardUI() {
    const {app, classes, activityData, isDrawerHidden} = this.props;
    const {addCardError, saveCard, isAddCardLoaded, isTokenizingCard} = this.state;
    const extraSpace = isDrawerHidden ? 16 : 20;
    return (
      <React.Fragment>
      <SectionHeaderView labelId={'payment.addNewCard'} />
        <div className={classes.viewRowFullWidth} >
          <div className={classes.flexColumn} style={{marginLeft: -extraSpace, marginRight: -extraSpace, alignItems: 'flex-start'}}>
            <div className={classes.mainContainer} style={{maxWidth: 600 + extraSpace, paddingLeft: !app.isLTR ? extraSpace : 0, paddingRight: app.isLTR ? extraSpace : 0}}>
              <form action="/charge" id="form-container" method="post">
                <div id="element-container"></div>
                {/*{isAddCardLoaded ?*/}
                  <div className={classes.viewColumnFullWidthNoCenter1} style={{paddingLeft: app.isLTR ? extraSpace : 0, paddingRight: !app.isLTR ? extraSpace : 0, opacity: isAddCardLoaded ? 1 : 0.5}}>
                    <Space horizontalSpace={2}/>
                    <div style={{marginLeft: app.isLTR ? 70 : 0, marginRight: !app.isLTR ? 60 : 0}}>
                      <FormControl>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Checkbox
                                size={'medium'}
                                icon={<ImageIcon src={require('src/images/ic_square.png')} width={20} height={20} />}
                                checkedIcon={<ImageIcon src={require('src/images/ic_square_check.png')} width={20} height={20} />}
                                checked={saveCard} onChange={this.onSaveCardToggle} />
                            }
                            label={this.context.intl.formatMessage({id: 'payment.saveCard'})}
                          />
                        </FormGroup>
                      </FormControl>
                    </div>
                    <Space horizontalSpace={2}/>
                    <Button
                      fullWidth
                      size={'large'}
                      disableElevation={true}
                      disabled={isTokenizingCard}
                      color={'primary'}
                      variant={'contained'}
                      onClick={this.onGenerateNewCardTokenClicked}>
                      {this.context.intl.formatMessage({id: 'payment.payWithValue'}, {value1: activityData.planPayCurrency, value2: activityData.planPay})}
                    </Button>
                    <FieldSpace/>
                    {addCardError ?
                      <ErrorText error={addCardError}/>
                      : null
                    }
                  </div>
                {/*  : null*/}
                {/*}*/}
              </form>
              {!isAddCardLoaded || isTokenizingCard ?
                <div style={{position: 'absolute', top: 0, left: extraSpace, right: extraSpace, bottom: extraSpace, display: 'flex', flexDirection: 'column'}}>
                  <Skeleton variant={'rect'} animation={'wave'} className={classes.flexColumn} style={{borderRadius: BORDER_RADIUS}}/>
                </div>
                : null
              }
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  onSaveCardToggle = (event) => {
    this.setState({saveCard: !this.state.saveCard});
  };

  onRetryClicked = () => {
    if (this.state.isInAddCard) {

    } else {
      this.makeApiToFetchCards();
    }
  }

  makeApiToFetchCards() {
    this.setState({isFetching: true});
    this.props.fetchSavedCards().then((response) => {
      const cards = response.data.data;
      const isInAddCard = !cards || cards.length === 0;
      this.setState({isFetching: false, cards: cards, isInAddCard: isInAddCard, saveCard: isInAddCard ? true : false}, () => {
        if (isInAddCard) {
          this.processAddCardRecur();
        }
      });
    }).catch((response) => {
      let error = null;
      if (response.data && response.data.error) {
        error = response.data.error;
      } else if (response.error === 'NETWORK_ERROR') {
        error = this.context.intl.formatMessage({id: 'generic.server_not_reachable'});
      } else {
        error = this.context.intl.formatMessage({id: 'generic.server_error_msg'});
      }
      this.setState({isFetching: false, cards: null, error: error});
    });
  }

}

ManageActivityPayment.propTypes = {
  classes: PropTypes.object,
  activityData: PropTypes.object,
  moveNextCallback: PropTypes.func.isRequired,
  onDataUpdated: PropTypes.func.isRequired,
};

ManageActivityPayment.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    app: state.app,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchSavedCards: () => dispatch(fetchSavedCards()),
    deletePaymentCard: (id) => dispatch(deletePaymentCard(id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
  ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
  ['isDrawerHidden', theme => theme.breakpoints.down('sm'), {defaultMatches: true}]
])(ManageActivityPayment)));
